import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import api, { TRY } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function NotificationBell({ goTo }) {
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(null);

  useEffect(() => {
    const load = () => {
      api.get("/reminders/overdue").then((r) => setData(r.data)).catch(() => {});
      api.get("/reminders/missing-entries").then((r) => setMissing(r.data)).catch(() => {});
    };
    load();
    const id = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  const count = (data?.customer_count || 0) + (data?.supplier_count || 0) + (missing?.count > 0 ? 1 : 0);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className="relative h-9 w-9 rounded-lg border border-border flex items-center justify-center hover:bg-accent transition-colors">
          <Bell className="h-4 w-4" />
          {count > 0 && (
            <span data-testid="notification-badge" className="absolute -top-1.5 -right-1.5 h-5 min-w-5 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center">
              {count}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notification-panel">
        <div className="px-4 py-3 border-b border-border">
          <div className="font-heading font-semibold text-sm">Vade Hatırlatmaları</div>
          <div className="text-xs text-muted-foreground">
            {count > 0 ? `${data?.customer_count || 0} alacak · ${data?.supplier_count || 0} tedarikçi borcu` : "Vadesi geçen kayıt yok"}
          </div>
        </div>
        <div className="max-h-80 overflow-y-auto divide-y divide-border">
          {missing?.count > 0 && (
            <button onClick={() => goTo("daily-entry")} data-testid="notification-missing-entries" className="w-full text-left px-4 py-2.5 hover:bg-accent/50 transition-colors bg-amber-400/5">
              <div className="text-sm font-medium text-amber-400">Bugün {missing.count} müşterinin kişi girişi eksik</div>
              <div className="text-[11px] text-muted-foreground truncate">{missing.missing.map((m) => m.name).join(", ")}</div>
            </button>
          )}
          {data?.customer_count > 0 && <div className="px-4 py-1.5 text-[10px] uppercase tracking-wider font-semibold text-rose-400 bg-rose-500/5">Alacaklar (Müşteri) · {TRY(data.total_overdue)}</div>}
          {(data?.items || []).map((it) => (
            <button key={it.customer_id} onClick={() => goTo("ledger")}
              className="w-full text-left px-4 py-2.5 hover:bg-accent/50 transition-colors">
              <div className="flex justify-between gap-2">
                <span className="text-sm font-medium truncate">{it.name}</span>
                <span className="font-mono text-sm text-rose-400 font-semibold">{TRY(it.overdue_amount)}</span>
              </div>
              <div className="text-[11px] text-muted-foreground">{it.count} fatura · {it.days_overdue} gün gecikmiş</div>
            </button>
          ))}
          {data?.supplier_count > 0 && <div className="px-4 py-1.5 text-[10px] uppercase tracking-wider font-semibold text-amber-400 bg-amber-400/5" data-testid="notification-supplier-section">Borçlar (Tedarikçi) · {TRY(data.supplier_total_overdue)}</div>}
          {(data?.supplier_items || []).map((it) => (
            <button key={it.supplier_id} onClick={() => goTo("suppliers")} data-testid={`notification-supplier-${it.supplier_id}`}
              className="w-full text-left px-4 py-2.5 hover:bg-accent/50 transition-colors">
              <div className="flex justify-between gap-2">
                <span className="text-sm font-medium truncate">{it.name}</span>
                <span className="font-mono text-sm text-amber-400 font-semibold">{TRY(it.overdue_amount)}</span>
              </div>
              <div className="text-[11px] text-muted-foreground">{it.count} fatura · {it.days_overdue} gün gecikmiş</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
